import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { FiCheck, FiX, FiRefreshCw } from 'react-icons/fi';
import '../../styles/Settings.css';
const OAuthCallbackPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [message, setMessage] = useState('Processing...');
    useEffect(() => {
        const errorParam = searchParams.get('error');
        if (errorParam) {
            setStatus('error');
            setMessage(errorParam || 'OAuth failed');
            if (window.opener) {
                window.opener.postMessage({
                    type: 'composio-oauth-complete',
                    status: 'error',
                    error: errorParam,
                }, window.location.origin);
            }
            const t = setTimeout(() => window.close(), 4000);
            return () => clearTimeout(t);
        }
        setStatus('success');
        setMessage('App connected successfully!');
        if (window.opener) {
            window.opener.postMessage({
                type: 'composio-oauth-complete',
                status: 'success',
            }, window.location.origin);
        }
        const t = setTimeout(() => window.close(), 250);
        return () => clearTimeout(t);
    }, [searchParams]);
    const handleClose = () => {
        window.close();
    };
    return (<div className="settings-page oauth-callback-page">
      <div className="oauth-callback-container">
        <div className={`oauth-callback-icon oauth-callback-icon--${status}`}>
          {status === 'loading' && <FiRefreshCw className="spin" size={48}/>}
          {status === 'success' && <FiCheck size={48}/>}
          {status === 'error' && <FiX size={48}/>}
        </div>
        
        <h1 className="oauth-callback-title">
          {status === 'loading' && 'Processing...'}
          {status === 'success' && 'Connected!'}
          {status === 'error' && 'Connection Failed'}
        </h1>
        
        <p className="oauth-callback-message">{message}</p>

        {status === 'error' && (<button className="oauth-callback-close-btn" onClick={handleClose}>
            Close Window
          </button>)}
      </div>

      <style>{`
        .oauth-callback-page {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
        }
        
        .oauth-callback-container {
          text-align: center;
          padding: 3rem;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 16px;
          border: 1px solid rgba(255, 255, 255, 0.1);
          max-width: 400px;
        }
        
        .oauth-callback-icon {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
        }
        
        .oauth-callback-icon--loading {
          background: rgba(59, 130, 246, 0.2);
          color: #60a5fa;
        }
        
        .oauth-callback-icon--success {
          background: rgba(34, 197, 94, 0.2);
          color: #4ade80;
        }
        
        .oauth-callback-icon--error {
          background: rgba(239, 68, 68, 0.2);
          color: #f87171;
        }
        
        .oauth-callback-title {
          font-size: 1.5rem;
          font-weight: 600;
          color: #fff;
          margin-bottom: 0.5rem;
        }
        
        .oauth-callback-message {
          color: rgba(255, 255, 255, 0.7);
          margin-bottom: 1.5rem;
        }

        .oauth-callback-close-btn {
          padding: 0.75rem 1.5rem;
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 8px;
          color: #fff;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        
        .oauth-callback-close-btn:hover {
          background: rgba(255, 255, 255, 0.15);
        }
        
        .spin {
          animation: spin 1s linear infinite;
        }
        
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>);
};
export default OAuthCallbackPage;
